<template>
  <permission-gate
    moduleKey="materiales"
    :showNoEditAlert="true"
  >
    <template #default="{ canEdit }">
      <main-breadcrumb
        :items="items"
        showBackButton
      ></main-breadcrumb>
      <main-buttons-bar :align="'space-between'">
        <template #left>
          <custom-title>Detalle de Item</custom-title>
        </template>
      </main-buttons-bar>
      <detail-container>
        <config-validator
          :keys="['tipo_item_mezcla', 'tipo_item_componente', 'categoria_item_material_resultante']"
        />
        <el-form
          ref="formRef"
          :model="material"
          :rules="formRules"
          size="default"
        >
          <el-row class="row-form">
            <el-col :span="4">
              <el-form-item prop="CodigoAdicional">
                <custom-input
                  v-model="material.CodigoAdicional"
                  :label="'Código adicional'"
                  :settings="{
                    placeholder: 'Ingresar código adicional',
                  }"
                />
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item prop="CodigoEquivalente">
                <custom-input
                  v-model="material.CodigoEquivalente"
                  :label="'Código equivalente'"
                  :settings="{
                    placeholder: 'Ingresar código equivalente',
                  }"
                />
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item prop="Tipo">
                <el-col :span="24">
                  <div class="label">Tipo</div>
                  <el-select
                    v-model="material.Tipo"
                    placeholder="Seleccionar tipo"
                    @update:modelValue="handleTipo"
                  >
                    <el-option
                      v-for="option in useItemTipo().itemTipos"
                      :key="option"
                      :label="option"
                      :value="option"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>

            <el-col :span="2">
              <el-form-item>
                <custom-switch
                  v-model="material.Activo"
                  label="Activo"
                  :spanColumn="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="2">
              <el-form-item>
                <custom-switch
                  v-model="material.EsGenerico"
                  label="Genérico"
                  :spanColumn="2"
                />
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item style="margin-left: 5%">
                <custom-data
                  :data="
                    material.FechaActualizacion
                      ? getDate('dd/mm/yyyy', material.FechaActualizacion)
                      : ''
                  "
                  :label="'Fecha actualización'"
                  :spanColumn="24"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row
            v-if="material.Tipo && material.Tipo.toLowerCase() == 'producto terminado'"
            class="row-form"
          >
            <el-col :span="15">
              <input-additional-clients v-model="material.MaterialClientes" />
            </el-col>
          </el-row>
          <el-row class="row-form">
            <el-col :span="12">
              <el-form-item prop="DescripcionInterna">
                <custom-input
                  v-model="material.DescripcionInterna"
                  :label="'Descripción'"
                  :settings="{ placeholder: 'Ingresar descripción' }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="DescripcionComercial">
                <custom-input
                  v-model="material.DescripcionComercial"
                  :label="'Descripción Comercial'"
                  :settings="{ placeholder: 'Ingresar descripción comercial' }"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="row-form">
            <el-col :span="12">
              <el-form-item
                prop="Descripción visible al cliente"
                style="width: 100%"
              >
                <custom-input
                  v-model="material.DescripcionCliente"
                  :label="'Descripción visible al cliente'"
                  :settings="{ placeholder: 'Ingresar descripción' }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                prop="Descripción para reportes y rótulos "
                style="width: 100%"
              >
                <custom-input
                  v-model="material.DescripcionReporte"
                  :label="'Descripción para reportes y rótulos '"
                  :settings="{ placeholder: 'Ingresar descripción' }"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="row-form">
            <el-col :span="4">
              <el-form-item prop="MateriaPrimaFamilia">
                <el-col :span="24">
                  <div class="custom-label">Familia Item</div>
                  <el-autocomplete
                    v-model="familiaDescripcion"
                    size="default"
                    :value-key="'Descripcion'"
                    :fetch-suggestions="handleSearch"
                    clearable
                    placeholder="Ingresar familia"
                    @select="handleFamiliaSelect"
                  />
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="MaterialTipo">
                <custom-select
                  v-model="material.MaterialTipo"
                  :label="'Tipo Item'"
                  :settings="{
                    placeholder: 'Seleccionar tipo de Item',
                    options: materialTipoList,
                  }"
                  @update:modelValue="handleMaterialTipoChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="Moneda">
                <custom-select
                  v-model="material.Moneda"
                  :label="'Moneda'"
                  :settings="{
                    placeholder: 'Seleccionar moneda',
                    options: monedaList,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="Costo">
                <custom-input-number
                  v-model="material.Costo"
                  :label="'Costo'"
                  :settings="{
                    placeholder: 'Costo',
                    min: 0,
                    precision: 4,
                    step: 0.01,
                    controls: false,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="Precio">
                <custom-input-number
                  v-model="material.Precio"
                  :label="'Precio'"
                  :settings="{
                    placeholder: 'Precio',
                    min: 0,
                    precision: 4,
                    step: 0.01,
                    controls: false,
                  }"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="row-form">
            <el-col :span="4">
              <el-form-item prop="CantidadUnidadesMedida">
                <el-col>
                  <div class="label">Cantidad unidades medida</div>
                  <el-radio-group
                    v-model="material.CantidadUnidadesMedida"
                    :disabled="TieneMovimientoStock"
                    @change="handlChangeCantidadUnidadesMedida"
                  >
                    <el-radio-button
                      label="1"
                      :value="1"
                    />
                    <el-radio-button
                      label="2"
                      :value="2"
                    />
                    <el-radio-button
                      label="3"
                      :value="3"
                    />
                  </el-radio-group>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item prop="UnidadMedida">
                <custom-select
                  v-model="material.UnidadMedida"
                  :label="'Unidad medida'"
                  :settings="{
                    placeholder: 'Seleccionar unidad medida',
                    options: unidadesMedida,
                  }"
                />
              </el-form-item>
            </el-col>

            <el-col :span="3">
              <el-form-item prop="CodigoCategoriaIVA">
                <custom-select
                  v-model="material.CategoriaIVA"
                  :label="'Categoría IVA'"
                  :settings="{
                    placeholder: 'Seleccionar categoría IVA',
                    options: categoriasIVA,
                    clearable: true,
                  }"
                  @update:modelValue="handleCategoriaIVAChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="TiempoEntrega">
                <custom-input-number
                  v-model="material.TiempoEntrega"
                  :label="'Tiempo entrega'"
                  :settings="{
                    placeholder: 'Tiempo entrega',
                    min: 0,
                    precision: 0,
                    step: 0.01,
                    controls: false,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="CodigoProveedor">
                <CustomSearchAutocomplete
                  v-model="material.Proveedor"
                  label="Proveedor"
                  :spanColumn="24"
                  :minChars="3"
                  :fieldKey="'Codigo'"
                  :fieldLabel="'Descripcion'"
                  :settings="{
                    placeholder: 'Ingresar el proveedor',
                    clearable: true,
                    size: 'default',
                  }"
                  :pagination="{
                    enabled: true,
                    page: 1,
                    limit: 250,
                  }"
                  @search="handleProveedorSearch"
                  @select="handleProveedorSelect"
                  @clear="handleProveedorClear"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <el-col :span="6">
                  <custom-switch
                    v-model="material.Exact"
                    label="Exacto"
                    :spanColumn="24"
                  />
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="row-form">
            <el-col :span="5">
              <el-form-item prop="UnidadMedidaSecundaria">
                <custom-select
                  v-model="material.UnidadMedidaSecundaria"
                  label="Unidad medida secundaria"
                  :settings="{
                    placeholder: 'Seleccionar unidad medida',
                    options: unidadesMedida,
                    disabled: (material.CantidadUnidadesMedida || 1) < 2,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item style="margin-left: 1%">
                <custom-switch
                  v-model="material.RelacionFija12"
                  label="Relación fija U1-2"
                  :settings="{
                    disabled: (material.CantidadUnidadesMedida || 1) < 2,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="FactorConversion">
                <custom-input-number
                  v-model="material.FactorConversion"
                  label="Factor conversión U1-2"
                  :settings="{
                    placeholder: 'Factor conversión',
                    min: 0,
                    precision: 4,
                    step: 0.01,
                    controls: false,
                    disabled:
                      (material.CantidadUnidadesMedida || 1) < 2 || !material.RelacionFija12,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="CantidadMinima">
                <custom-input-number
                  v-model="material.CantidadMinima"
                  label="Cantidad mínima"
                  :settings="{
                    placeholder: 'Cantidad mínima',
                    min: 0,
                    precision: 2,
                    step: 0.01,
                    controls: false,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="CantidadReposicion">
                <custom-input-number
                  v-model="material.CantidadReposicion"
                  label="Cantidad de reposición"
                  :settings="{
                    placeholder: 'Cantidad de reposición',
                    min: material.CantidadMinima || 0,
                    precision: 2,
                    step: 0.01,
                    controls: false,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="CantidadMaxima">
                <custom-input-number
                  v-model="material.CantidadMaxima"
                  label="Cantidad máxima"
                  :settings="{
                    placeholder: 'Cantidad máxima',
                    min: material.CantidadMinima || 0,
                    precision: 2,
                    step: 0.01,
                    controls: false,
                  }"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="row-form">
            <el-col :span="5">
              <el-form-item prop="UnidadMedidaTerciaria">
                <custom-select
                  v-model="material.UnidadMedidaTerciaria"
                  label="Unidad medida terciaria"
                  :settings="{
                    placeholder: 'Seleccionar unidad medida',
                    options: unidadesMedida,
                    disabled: (material.CantidadUnidadesMedida || 1) < 3,
                  }"
                >
                </custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item style="margin-left: 1%">
                <custom-switch
                  v-model="material.RelacionFija23"
                  :label="'Relación fija U2-3'"
                  :settings="{
                    disabled: (material.CantidadUnidadesMedida || 1) < 3,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="FactorConversion23">
                <custom-input-number
                  v-model="material.FactorConversion23"
                  label="Factor conversión U2-3"
                  :settings="{
                    placeholder: 'Factor conversión',
                    min: 0,
                    precision: 4,
                    step: 0.01,
                    controls: false,
                    disabled:
                      (material.CantidadUnidadesMedida || 1) < 3 || !material.RelacionFija23,
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <custom-switch
                  v-model="material.AdministraSeries"
                  label="Administra series"
                  :settings="{ disabled: TieneMovimientoStock }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <custom-switch
                  v-model="material.AdministraLotes"
                  label="Administra lotes"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <custom-switch
                  v-model="material.AdministraOT"
                  label="Administra OT"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <custom-switch
                  v-model="material.AdministraUbicaciones"
                  label="Administra ubicaciones"
                  :settings="{ disabled: TieneMovimientoStock }"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <section
            v-if="visibleDynamicFields.length > 0 || camposNulosDisponibles.length > 0"
            class="campos-adicionales"
          >
            <div class="campos-adicionales__header">
              <span class="campos-adicionales__titulo">Campos adicionales</span>
              <span class="campos-adicionales__contador"> {{ camposConValor }} con valor </span>
            </div>

            <el-row
              v-if="visibleDynamicFields.length > 0"
              class="row-form campos-adicionales__fila"
            >
              <el-col
                v-for="field in visibleDynamicFields"
                :key="field.prop"
                :span="8"
                class="campo-dinamico"
              >
                <el-tooltip
                  v-if="!field.bloqueado && !campoVacio(field)"
                  content="Vaciar valor"
                  placement="top"
                >
                  <el-button
                    class="campo-dinamico__quitar"
                    link
                    type="danger"
                    @click="handleVaciarCampo(field.atributo)"
                  >
                    <IconEraser />
                  </el-button>
                </el-tooltip>
                <custom-select-orientacion-fibra
                  v-if="field.type === 'orientacion'"
                  v-model="material[field.prop]"
                  :show="true"
                  :prop-name="field.prop"
                  :label="field.label"
                />
                <el-form-item
                  v-else
                  :prop="field.prop"
                  style="width: 100%"
                >
                  <color-select
                    v-if="field.type === 'color'"
                    v-model="material.CodigoColor"
                    :preload="material.Color || null"
                    :settings="{
                      label: field.label,
                      hideLabel: false,
                      teleported: true,
                      size: 'default',
                      width: '100%',
                    }"
                  />
                  <custom-select
                    v-else-if="field.type === 'select'"
                    v-model="material[field.prop]"
                    :label="field.label"
                    :spanColumn="24"
                    :settings="{
                      placeholder: field.selectSettings?.placeholder,
                      options: field.optionsRef === 'formaList' ? formaList : [],
                      clearable: true,
                    }"
                    :fieldKey="'Codigo'"
                    :fieldLabel="'Descripcion'"
                  ></custom-select>
                  <custom-input
                    v-else-if="field.type === 'text'"
                    v-model="material[field.prop]"
                    :spanColumn="24"
                    :label="field.label"
                    :settings="field.inputSettings"
                  />
                  <custom-input-number
                    v-else
                    :spanColumn="24"
                    :label="field.label"
                    :settings="field.settings"
                    :model-value="getDynamicNumberModel(field.prop)"
                    @update:model-value="(val) => setDynamicNumberModel(field.prop, val)"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row
              v-if="camposNulosDisponibles.length > 0"
              class="row-form campos-adicionales__agregar"
            >
              <el-col :span="6">
                <div class="custom-label">Agregar campo</div>
                <el-select
                  :model-value="null"
                  placeholder="Seleccionar campo a agregar"
                  filterable
                  @update:modelValue="agregarCampo"
                >
                  <el-option
                    v-for="campo in camposNulosDisponibles"
                    :key="campo.atributo"
                    :label="campo.etiqueta"
                    :value="campo.atributo"
                  />
                </el-select>
              </el-col>
            </el-row>
          </section>

          <!-- Sección Fórmula (tipo Mezcla compone con componentes; categoría Bobina Extrusión compone con mezclas) -->
          <material-formula
            v-if="admiteFormula"
            v-model="material.MaterialFormula"
            :tipo-item="isMezcla ? tipoItemComponente : tipoItemMezcla"
            :columna-label="isMezcla ? 'Componente' : 'Mezcla'"
            @propiedades-calculadas="aplicarPropiedadesDesdeFormula"
          />

          <!-- Atributos Dinámicos -->
          <MaterialAtributosForm
            ref="atributosFormRef"
            v-model="material.AtributosAdicionales"
            :codigoMaterialCategoria="material.CodigoMaterialCategoria"
            :readonly="false"
            layout="grid"
            :columns="2"
          />

          <div
            v-if="canEdit"
            class="container"
          >
            <custom-confirm-buttons
              :disabled="false"
              :showLoading="isSaving"
              :confirmText="'Guardar'"
              :cancelText="'Cancelar'"
              @on-cancel="onCancel"
              @on-confirm="saveMaterial"
            ></custom-confirm-buttons>
          </div>
        </el-form>
      </detail-container>
    </template>
  </permission-gate>
</template>

<script setup>
import {
  ref,
  onBeforeMount,
  computed,
} from 'vue';
import { storeToRefs } from 'pinia';
import IconEraser from '~icons/mdi/eraser';
import ColorSelect from '@/shared/components/tintas/color_select.vue';
import CustomConfirmButtons from '@/shared/components/custom_confirm_buttons.vue';
import MaterialAtributosForm from '@/shared/components/atributos-dinamicos/MaterialAtributosForm.vue';
import MaterialFormula from './material_formula.vue';
import CustomSwitch from '@/shared/components/custom_switch.vue';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import CustomSelectOrientacionFibra from '@/shared/components/custom_select_orientacion_fibra.vue';
import CustomSearchAutocomplete from '@/shared/components/custom_search_autocomplete.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CustomData from '@/shared/components/custom_data.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import {
  milimeterVisualTo,
  visualToMilimeter,
  isDimensionesProp,
} from '@/shared/composables/useUnitConversion';
import { useCamposDinamicos } from '@/shared/composables/useCamposDinamicos.js';
import { UnidadMedida } from '@/enum/unidad_medida';
import { useMaterialTipoStore } from '@/stores/material-tipo.js';
import { useMaterialStore } from '@/stores/materiales_store.js';
import { useMateriaPrimaFamiliaStore } from '@/stores/materia_prima_familia/materia_prima_familia_store.js';
import { useMonedaStore } from '@/stores/moneda/moneda_store';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import { ElNotification } from 'element-plus';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import getDate from '@/shared/components/utils.js';
import { useUnidadMedidaStore } from '@/stores/unidad_medida/unidad_medida_store.js';
import { useCategoriaIVAStore } from '@/stores/categoria_iva_store.js';
import { useFormaStore } from '@/stores/forma/forma_store';
import { useSupplierStore } from '@/views/supplier/stores/supplier_store';
import { useItemTipo } from '@/shared/composables/useItemTipo.js';
import PermissionGate from '@/shared/components/permission_gate.vue';
import inputAdditionalClients from '@/shared/components/input_additional_clients.vue';
import ConfigValidator from '@/shared/components/config-validator.vue';
import { useConfiguracionStore } from '@/stores/configuracion-general';

const unidadMedidaStore = useUnidadMedidaStore();

const materialStore = useMaterialStore();
const materialTipoStore = useMaterialTipoStore();
const monedaStore = useMonedaStore();
const materiaPrimaFamiliaStore = useMateriaPrimaFamiliaStore();
const categoriaIVAStore = useCategoriaIVAStore();
const configuracionGeneralStore = useConfiguracionStore();

const route = useRoute();
const router = useRouter();

const {
  resetMaterial,
  setFamiliaMaterial,
  updateMaterialHTTP,
  setCodigosMaterial,
  findMaterialByCodigoHTTP,
  createMaterialHTTP,
  loadCamposDisponiblesHTTP,
} = materialStore;
const { material, TieneMovimientoStock, camposDisponibles } = storeToRefs(materialStore);
const { materialTipoList } = storeToRefs(materialTipoStore);
const { unidadesMedida } = storeToRefs(unidadMedidaStore);
const { categoriasIVA } = storeToRefs(categoriaIVAStore);
const { firstConfiguraciones } = configuracionGeneralStore;
const { tipoItemMezcla, tipoItemComponente, categoriaItemMaterialResultante } =
  storeToRefs(configuracionGeneralStore);

// Ref para el componente de atributos dinámicos
const atributosFormRef = ref(null);
const isSaving = ref(false);

const formaStore = useFormaStore();
const { monedaList } = storeToRefs(monedaStore);
const { searchMateriaPrimaFamiliaHTTP } = materiaPrimaFamiliaStore;
const { firstMaterialTipo } = materialTipoStore;
const { firstMoneda } = monedaStore;
const { formaList } = storeToRefs(formaStore);

const supplierStore = useSupplierStore();

const items = [
  { label: 'Inicio', to: '/page/material/list', replace: false },
  { label: 'Edit', to: null, replace: false },
];
const formRef = ref(null);

const DYN_ATTRS = [
  'Ancho',
  'Alto',
  'Largo',
  'Espesor',
  'Gramaje',
  'Densidad',
  'Diametro',
  'Rendimiento',
  'Color',
  'Rigidez',
  'Rasgado',
  'Punzonado',
  'TemperaturaSellado',
  'Termoencogible',
  'Retortable',
  'Transparencia',
  'Brillo',
  'Opacidad',
  'Base',
  'ComponentePrincipal',
  'Solvente',
  'CompatibilidadAdhesivo',
  'CompatibilidadTinta',
  'AptoAlimentos',
  'Laminable',
  'Termorresistente',
  'ResistenciaQuimica',
  'ResistenciaLuz',
  'ResistenciaFriccion',
  'TratamientoCorona',
  'CoeficienteFriccion',
  'Antiestatico',
  'Reciclable',
  'Biodegradable',
  'Compostable',
  'LibreDeSolventesAromaticos',
  'BajoVOC',
  'Viscosidad',
  'Peso',
  'Curado',
  'Forma',
  'TipoFlauta',
  'Fibra',
];

const FIELD_META = {
  Color: { type: 'color' },
  Fibra: { type: 'orientacion' },
  Forma: { type: 'select', valueProp: 'Forma', optionsRef: 'formaList' },
};

//const shouldShowAtributos = computed(() => atributosFormRef.value?.shouldShow ?? false);

const isMezcla = computed(() => {
  // `tipoItemMezcla` sale de ConfiguracionGeneral como texto; el codigo es numerico.
  return Number(material.value?.CodigoMaterialTipo) === Number(tipoItemMezcla.value);
});

// Densidad y gramaje se derivan de la fórmula cuando el material tiene una cargada.
const PROPIEDADES_DESDE_FORMULA = ['Densidad', 'Gramaje'];

const isMaterialResultante = computed(() => {
  const codigoCategoria =
    material.value?.MaterialTipo?.CodigoMaterialCategoria ??
    material.value?.CodigoMaterialCategoria;
  if (codigoCategoria == null) return false;
  if (!(Number(categoriaItemMaterialResultante.value) > 0)) return false;
  // Idem: `categoriaItemMaterialResultante` es texto (ver el Number() de arriba).
  return Number(codigoCategoria) === Number(categoriaItemMaterialResultante.value);
});

/** Materiales que admiten fórmula: mezclas (componentes) y material resultante (mezclas). */
const admiteFormula = computed(() => isMezcla.value || isMaterialResultante.value);

/**
 * Con filas en la fórmula, densidad y gramaje salen de ahí y los campos se bloquean. Sin
 * filas quedan libres para cargarlos a mano, que es el único modo de completarlos: el
 * backend guarda lo que reciba, sin recalcular.
 */
const densidadYGramajeDesdeFormula = computed(
  () => admiteFormula.value && (material.value?.MaterialFormula?.length ?? 0) > 0,
);

/**
 * Vuelca en el material la densidad y el gramaje derivados de la fórmula, en cada cambio de
 * las filas. Un null significa que ningún ítem aporta ese dato: ahí se deja lo que hubiera
 * en vez de borrarlo.
 */
const aplicarPropiedadesDesdeFormula = ({ Densidad, Gramaje }) => {
  if (!densidadYGramajeDesdeFormula.value) return;
  if (Densidad != null) material.value.Densidad = Densidad;
  if (Gramaje != null) material.value.Gramaje = Gramaje;
};

const ATTR_TYPE = {
  Color: 'color',
  Forma: 'select',
  Ancho: 'number',
  Alto: 'number',
  Largo: 'number',
  Espesor: 'number',
  Gramaje: 'number',
  Densidad: 'number',
  Diametro: 'number',
  Rendimiento: 'number',
  TemperaturaSellado: 'number',
  Peso: 'number',
  Rigidez: 'text',
  Rasgado: 'text',
  Punzonado: 'text',
  Termoencogible: 'text',
  Retortable: 'text',
  Transparencia: 'text',
  Brillo: 'text',
  Opacidad: 'text',
  Base: 'text',
  ComponentePrincipal: 'text',
  Solvente: 'text',
  CompatibilidadAdhesivo: 'text',
  CompatibilidadTinta: 'text',
  AptoAlimentos: 'text',
  Laminable: 'text',
  Termorresistente: 'text',
  ResistenciaQuimica: 'text',
  ResistenciaLuz: 'text',
  ResistenciaFriccion: 'text',
  TratamientoCorona: 'text',
  CoeficienteFriccion: 'text',
  Antiestatico: 'text',
  Reciclable: 'text',
  Biodegradable: 'text',
  Compostable: 'text',
  LibreDeSolventesAromaticos: 'text',
  BajoVOC: 'text',
  Viscosidad: 'text',
  Curado: 'text',
  TipoFlauta: 'text',
};

const NUMBER_META = {
  Ancho: { precision: 3, step: 0.001 },
  Alto: { precision: 3, step: 0.001 },
  Largo: { precision: 3, step: 0.001 },
  Espesor: { precision: 3, step: 0.001 },
  Gramaje: { precision: 3, step: 0.001 },
  Densidad: { precision: 4, step: 0.0001 },
  Diametro: { precision: 3, step: 0.001 },
  Rendimiento: { precision: 3, step: 0.001 },
  TemperaturaSellado: { precision: 4, step: 0.0001 },
  Peso: { precision: 4, step: 0.0001 },
};

// Atributo del diccionario -> propiedad real del material. El payload nunca debe llevar el
// nombre del atributo (ej. `Fibra`): el backend rechaza propiedades que no son columnas.
const VALUE_PROP = {
  Color: 'CodigoColor',
  Forma: 'Forma',
  Fibra: 'OrientacionFibra',
};

const unidadDimensiones = computed(() => {
  const cod =
    material.value?.MaterialTipo?.MaterialCategoria?.CodigoUnidadMedidaDimensiones ?? null;

  if (cod === UnidadMedida.MILIMETRO) return 'mm';
  if (cod === UnidadMedida.PULGADA) return 'in';
  if (cod === UnidadMedida.CENTIMETRO) return 'cm';
  return '';
});

// solo se muestran los campos con valor al cargar y los que el usuario
// agrega desde el combo. `camposDisponibles` (diccionario del backend) define qué admite el tipo.
const {
  camposVisibles,
  camposNulosDisponibles,
  initVisibleFields,
  agregarCampo,
  vaciarCampo,
  limpiarNoDisponibles,
} = useCamposDinamicos({
  data: material,
  camposDisponibles,
  valueProp: VALUE_PROP,
  gestionados: DYN_ATTRS,
});

const etiquetaCampo = (campo) => {
  const base = campo.etiqueta || campo.atributo;
  if (['Ancho', 'Alto', 'Largo'].includes(campo.atributo)) {
    const unit = unidadDimensiones.value;
    return unit ? `${base} (${unit})` : base;
  }
  return base;
};

const visibleDynamicFields = computed(() =>
  camposVisibles.value.map((campo) => {
    const prop = campo.atributo;
    const t =
      FIELD_META[prop]?.type ??
      (campo.tipo ? (campo.tipo === 'number' ? 'number' : 'text') : (ATTR_TYPE[prop] ?? 'number'));
    const label = etiquetaCampo(campo);

    const base = {
      atributo: prop,
      bloqueado: densidadYGramajeDesdeFormula.value && PROPIEDADES_DESDE_FORMULA.includes(prop),
    };

    if (t === 'color') {
      return { ...base, prop: VALUE_PROP[prop] || 'CodigoColor', label, type: 'color' };
    }
    if (t === 'orientacion') {
      return { ...base, prop: VALUE_PROP[prop], label, type: 'orientacion' };
    }
    if (t === 'select') {
      const meta = FIELD_META[prop] || {};
      return {
        ...base,
        prop: meta.valueProp || prop,
        label,
        type: 'select',
        optionsRef: meta.optionsRef,
        selectSettings: { placeholder: `Seleccionar ${label.toLowerCase()}` },
      };
    }
    if (t === 'text') {
      return {
        ...base,
        prop,
        label,
        type: 'text',
        inputSettings: { placeholder: `Ingresar ${label.toLowerCase()}` },
      };
    }
    const numMeta = NUMBER_META[prop] || {};
    return {
      ...base,
      prop,
      label,
      type: 'number',
      settings: {
        placeholder: `Ingresar ${label.toLowerCase()}`,
        min: 0,
        precision: numMeta.precision ?? 0,
        step: numMeta.step ?? 0.01,
        controls: false,
        disabled: densidadYGramajeDesdeFormula.value && PROPIEDADES_DESDE_FORMULA.includes(prop),
      },
    };
  }),
);

// OrientacionFibra usa 0 como "sin orientación", que equivale a vacío.
const campoVacio = (field) => {
  const valor = material.value?.[field.prop];
  return (
    valor === null ||
    valor === undefined ||
    valor === '' ||
    (field.type === 'orientacion' && valor === 0)
  );
};

const camposConValor = computed(
  () => visibleDynamicFields.value.filter((field) => !campoVacio(field)).length,
);

const handleVaciarCampo = (atributo) => {
  vaciarCampo(atributo);
  // OrientacionFibra es NOT NULL (0 = sin orientación).
  if (material.value.OrientacionFibra == null) material.value.OrientacionFibra = 0;
};

function handleCategoriaIVAChange(item) {
  material.value.CodigoCategoriaIVA = item?.Codigo ?? null;
}

const pruneValuesForNewType = (nextMT) => {
  limpiarNoDisponibles();
  if (material.value.OrientacionFibra == null) material.value.OrientacionFibra = 0;
};

const esNumeroVacio = (val) => val === null || val === undefined || val === '';

// Las conversiones de unidad tratan null como 0; un campo vacío debe quedar vacío.
function getDynamicNumberModel(prop) {
  const raw = material.value?.[prop];

  if (esNumeroVacio(raw)) return null;

  if (isDimensionesProp(prop)) {
    return milimeterVisualTo(raw, unidadDimensiones.value);
  }

  return raw;
}

function setDynamicNumberModel(prop, visualVal) {
  if (esNumeroVacio(visualVal)) {
    material.value[prop] = null;
  } else if (isDimensionesProp(prop)) {
    material.value[prop] = visualToMilimeter(visualVal, unidadDimensiones.value);
  } else {
    material.value[prop] = visualVal;
  }
}
const formRules = ref({});

const handleTipo = (value) => {
  if (value && value.toLowerCase() !== 'producto terminado') {
    material.value.MaterialClientes = [];
  }
};

const updateFormRules = () => {
  formRules.value = {};
  let rules = {
    DescripcionInterna: [{ required: true, message: 'Ingresar descripción' }],
    MaterialTipo: [
      {
        validator: (rule, value, callback) => {
          if (!value || !value.Codigo) {
            callback(new Error('Seleccionar tipo Item'));
          } else {
            callback();
          }
        },
      },
    ],
    UnidadMedida: [
      {
        validator: (rule, value, callback) => {
          if (!value || !value.Codigo) {
            callback(new Error('Seleccionar unidad de medida'));
          } else {
            callback();
          }
        },
      },
    ],
  };

  if (material.value.CantidadUnidadesMedida > 1) {
    rules = {
      ...rules,
      UnidadMedidaSecundaria: [{ required: true, message: 'Ingresar unidad medida secundaria' }],
    };

    if (material.value.RelacionFija12) {
      rules = {
        ...rules,
        FactorConversion: [
          { required: true, message: 'Ingresar factor de conversión entre la unidad 1 y 2' },
        ],
      };
    }
  }
  if (material.value.CantidadUnidadesMedida > 2) {
    rules = {
      ...rules,
      UnidadMedidaTerciaria: [{ required: true, message: 'Ingresar unidad medida terciaria' }],
    };

    if (material.value.RelacionFija23) {
      rules = {
        ...rules,
        FactorConversion23: [
          { required: true, message: 'Ingresar factor de conversión entre la unidad 2 y 3' },
        ],
      };
    }
  }
  if (material.value.CantidadReposicion) {
    rules = {
      ...rules,
      CantidadReposicion: [
        {
          validator: (rule, value, callback) => {
            if (value <= material.value.CantidadMinima) {
              callback(new Error('La cantidad de reposición debe ser mayor a la cantidad mínima'));
            } else {
              callback();
            }
          },
        },
      ],
    };
  }
  if (material.value.CantidadMaxima) {
    rules = {
      ...rules,
      CantidadMaxima: [
        {
          validator: (rule, value, callback) => {
            if (value <= material.value.CantidadMinima) {
              callback(new Error('La cantidad máxima debe ser mayor a la cantidad mínima'));
            } else {
              callback();
            }
          },
        },
      ],
    };
  }
  formRules.value = rules;
};

const handlChangeCantidadUnidadesMedida = (value) => {
  if (value === 1) {
    material.value.UnidadMedidaSecundaria = null;
    material.value.FactorConversion = null;
    material.value.RelacionFija12 = null;
    material.value.CodigoUnidadMedidaTerciaria = null;
    material.value.FactorConversion23 = null;
    material.value.RelacionFija23 = null;
  } else if (value === 2) {
    material.value.CodigoUnidadMedidaTerciaria = null;
    material.value.FactorConversion23 = null;
    material.value.RelacionFija23 = null;
  }
};

async function handleMaterialTipoChange(newMaterialTipo) {
  setCodigosMaterial({ propiedad: 'CodigoMaterialTipo', valor: newMaterialTipo.Codigo });
  material.value.MaterialTipo = newMaterialTipo;
  await loadCamposDisponiblesHTTP(newMaterialTipo.Codigo);
  pruneValuesForNewType(newMaterialTipo);
  if (!camposDisponibles.value.some((c) => c.atributo === 'Color')) {
    delete material.value.CodigoColor;
  }
  initVisibleFields();
}

const onCancel = () => {
  resetMaterial();
  resetFormValidation();
  router.push('/page/material/list');
};

const familiaDescripcion = computed({
  get: () =>
    material.value.MateriaPrimaFamilia ? material.value.MateriaPrimaFamilia.Descripcion : '',
  set: (newValue) => {
    if (!material.value.MateriaPrimaFamilia) {
      material.value.MateriaPrimaFamilia = {};
    }
    material.value.MateriaPrimaFamilia.Descripcion = newValue;
  },
});

const handleFamiliaSelect = (familiaSeleccionada) => {
  setFamiliaMaterial({ propiedad: 'Codigo', valor: familiaSeleccionada.Codigo });
};
const handleSearch = async (query, cb) => {
  let results = [];
  if (query && query.length >= 3) {
    results = await searchMateriaPrimaFamiliaHTTP(query);
  }

  cb(results);
};
// onBeforeMount(async() => {

//   unidadMedidaStore.emptyList()
//   unidadMedidaStore.findAllUnidadMedidaHTTP({ page: 0, Activo: true })
//   await firstMaterialTipo(0)
//   firstMoneda()
//   const id = route.params.id
//   if (id && +id > 0) {
//     await findMaterialByCodigoHTTP(id)
//     const mt = material.value.MaterialTipo
//     if (mt && !mt.MaterialCategoria) {
//       const fromList = materialTipoList.value.find(x => x.Codigo === mt.Codigo)
//       if (fromList?.MaterialCategoria) {
//         material.value.MaterialTipo = { ...mt, MaterialCategoria: fromList.MaterialCategoria }
//       }
//     }
//   }
// })

const resetFormValidation = () => {
  if (formRef.value) {
    formRef.value.resetFields();
  }
};

const saveMaterial = async () => {
  updateFormRules();
  formRef.value.validate(async (valid) => {
    if (valid) {
      // Validar atributos dinámicos si existen
      if (atributosFormRef.value) {
        const atributosValidos = await atributosFormRef.value.validate();
        if (!atributosValidos) {
          ElNotification({
            title: 'Validación de atributos',
            message: 'Por favor, complete todos los atributos requeridos.',
            type: 'warning',
          });
          return;
        }
      }

      if (isMezcla.value || isMaterialResultante.value) {
        const formulas = material.value.MaterialFormula ?? [];
        // La fórmula sólo es obligatoria para Mezcla; en Material Resultante es opcional.
        if (isMezcla.value && formulas.length === 0) {
          ElNotification({
            title: 'Fórmula incompleta',
            message: 'Debe agregar al menos un material a la fórmula.',
            type: 'warning',
          });
          return;
        }
        if (formulas.length > 0) {
          const sinMaterial = formulas.some((f) => !f.CodigoMaterialFormula);
          if (sinMaterial) {
            ElNotification({
              title: 'Fórmula incompleta',
              message: 'Todos los materiales de la fórmula deben estar seleccionados.',
              type: 'warning',
            });
            return;
          }
          const total = formulas.reduce((sum, f) => sum + (Number(f.Proporcion) || 0), 0);
          if (Math.abs(total - 100) > 0.01) {
            ElNotification({
              title: 'Fórmula inválida',
              message: `La suma de proporciones debe ser 100%. Total actual: ${total.toFixed(2)}%`,
              type: 'warning',
            });
            return;
          }
        }
      }

      isSaving.value = true;

      try {
        useLoading().openLoading();

        const id = route.params.id;

        if (id && +id > 0) {
          await updateMaterialHTTP();
          useMessageSuccess().open(`El Item ha sido actualizado exitosamente!`);

          await findMaterialByCodigoHTTP(id);
          const mt = material.value.MaterialTipo;
          if (mt && !mt.MaterialCategoria) {
            const fromList = materialTipoList.value.find((x) => x.Codigo === mt.Codigo);
            if (fromList?.MaterialCategoria) {
              material.value.MaterialTipo = {
                ...mt,
                MaterialCategoria: fromList.MaterialCategoria,
              };
            }
          }
        } else {
          await createMaterialHTTP();
          useMessageSuccess().open(`El Item ha sido creado exitosamente!`);
          router.go(-1);
        }
      } catch (err) {
        useMessageError().open(`Ha ocurrido un error al intentar procesar los datos.`);
      } finally {
        useLoading().closeLoading();
        isSaving.value = false;
      }
    } else {
      ElNotification({
        title: 'Formulario incompleto',
        message: 'Por favor, revise los campos ingresados.',
        type: 'warning',
      });
    }
  });
};

const handleProveedorSearch = async (searchParams, callback) => {
  let results = [];
  if (searchParams.query && searchParams.query.length >= 3 && searchParams.query !== 'null') {
    results = await supplierStore.searchSuppliersHTTP(searchParams.query);
  }
  callback(results || []);
};

const handleProveedorClear = () => {
  setCodigosMaterial({ propiedad: 'Proveedor', valor: null });
};

const handleProveedorSelect = (valor) => {
  setCodigosMaterial({ propiedad: 'Proveedor', valor });
};

onBeforeMount(async () => {
  unidadMedidaStore.emptyList();
  unidadMedidaStore.findAllUnidadMedidaHTTP({
    page: 0,
    Activo: true,
    EsUnidadInventario: true,
    sortBy: 'Descripcion',
    sort: 'Asc',
  });
  await firstConfiguraciones();
  await firstMaterialTipo(0);
  firstMoneda();
  const id = route.params.id;
  if (id && +id > 0) {
    await findMaterialByCodigoHTTP(id);
    const mt = material.value.MaterialTipo;
    if (mt && !mt.MaterialCategoria) {
      const fromList = materialTipoList.value.find((x) => x.Codigo === mt.Codigo);
      if (fromList?.MaterialCategoria) {
        material.value.MaterialTipo = { ...mt, MaterialCategoria: fromList.MaterialCategoria };
      }
    }
    handlChangeCantidadUnidadesMedida(material.value.CantidadUnidadesMedida || 1);
    if (!Array.isArray(material.value.MaterialFormula)) material.value.MaterialFormula = [];
    initVisibleFields();
  }
});
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin: 5%;
}

.el-form {
  margin-top: 0;
}

.row-form :deep(.el-form-item__content) {
  padding-right: 20px !important;
}

/* Elimina los márgenes de los el-form-item */
.el-form-item {
  margin-top: 0;
  margin-bottom: 0;
}

.full-width {
  width: 100%;
}

.custom-label {
  font-weight: 700;
  color: #111;
}
.container {
  display: flex;
  justify-content: flex-end; /* Alinea todo el contenido al final del contenedor */
}

:deep(.el-input-number) {
  width: 100%;
}

.campos-adicionales {
  margin: 16px 0;
  padding: 16px 16px 20px;
  border: 1px solid var(--el-border-color-light);
  border-radius: 8px;
  background-color: var(--el-fill-color-lighter);
}

.campos-adicionales__header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--el-border-color-lighter);
}

.campos-adicionales__titulo {
  font-weight: 700;
  color: #111;
}

.campos-adicionales__contador {
  font-size: 12px;
  color: var(--el-text-color-secondary);
}

.campos-adicionales__ayuda {
  margin: -8px 0 16px;
  font-size: 12px;
  color: var(--el-text-color-secondary);
}

.campos-adicionales__fila {
  row-gap: 16px;
  margin-bottom: 16px;
}

.campo-dinamico {
  position: relative;
}

.campo-dinamico__quitar {
  position: absolute;
  top: 0;
  right: 20px;
  z-index: 1;
  height: 20px;
  padding: 0;
}
</style>
